module.exports = __webpack_public_path__ + "assets/GoldDelta2x.2265908f0e3447fc6ef66bc0ca93f3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldDelta2x.png
// module id = 807
// module chunks = 0